import * as React from 'react'
import { useRouter } from 'next/compat/router'

import { i18n, useSiteConfig } from '@thg-commerce/enterprise-core'
import { pushToEventGA4 } from '@thg-commerce/enterprise-metrics/src/data_layer/pushToDataLayer/utils'
import { useTheme } from '@thg-commerce/enterprise-pages/src/Product/theme'
import { SafeHtml } from '@thg-commerce/gravity-elements'
import { TextStyling } from '@thg-commerce/gravity-patterns'
import { styled } from '@thg-commerce/gravity-theme'

import { SizeGuideModal } from '../Modal/SizeGuideModal'
import { SizeGuideTrigger } from '../SizeGuideTrigger'

export interface SizeGuideContainerProps {
  sizeGuide?: string
  hasMarginBottom?: boolean
  modalLinkTextStyling?: TextStyling

  table?: {
    head?: {
      backgroundColor?: string
      color?: string
    }
  }
}

const StyledSafeHtml = styled(SafeHtml)`
  margin: 8px 0;
`

export const SizeGuideContainer = (props: SizeGuideContainerProps) => {
  const theme = useTheme()
  const { hasShoeSizeMeId, showSizeGuideInfoText } = useSiteConfig()
  const router = useRouter()
  const i18nText = {
    closeI18nText: {
      closeAriaLabel: i18n('general.modal.close.button.arialabel'),
      closeLabel: i18n('general.modal.close.button.label'),
    },
    title: i18n('product.sizeguide.heading.text'),
    sizeGuideContent: i18n('product.sizeguide.before.information.text'),
  }

  const [sizeGuideModalOpen, setSizeGuideModalOpen] = React.useState(false)

  const handleCloseModal = React.useCallback(() => {
    setSizeGuideModalOpen(false)

    pushToEventGA4({
      event: 'elysiumEvent',
      component: 'product size guide modal',
      eventData: {
        eventAction: 'Closed',
        eventCategory: 'Product | Size Guide modal',
        eventLabel: 'product Size Guide',
        eventPage: router?.asPath || '',
      },
      event_name: 'product_size_guide_closed',
      path: router?.asPath || '',
    })
  }, [router])

  if (!props.sizeGuide) {
    return null
  }

  return (
    <div
      style={
        theme.pageTheme.sizeGuide.alternateMargin
          ? { margin: theme.pageTheme.sizeGuide.alternateMargin }
          : {
              marginBottom:
                props.hasMarginBottom && !hasShoeSizeMeId ? '20px' : '0',
            }
      }
    >
      {showSizeGuideInfoText && (
        <StyledSafeHtml content={i18nText.sizeGuideContent} />
      )}

      <SizeGuideTrigger
        textStyling={props.modalLinkTextStyling}
        i18nText={{ triggerText: i18nText.title }}
        onClick={() => {
          setSizeGuideModalOpen(true)
        }}
        svg={theme.icons?.sizeGuide}
      />
      {sizeGuideModalOpen && (
        <SizeGuideModal
          i18nText={i18nText}
          onClose={handleCloseModal}
          content={props.sizeGuide}
        />
      )}
    </div>
  )
}
